import React, { useEffect } from 'react';

const CalendlyPopup = ({ children, className }) => {
  useEffect(() => {
    // Load Calendly script if not already loaded
    if (!document.getElementById('calendly-script')) {
      const head = document.querySelector('head');
      const script = document.createElement('script');
      script.id = 'calendly-script';
      script.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('async', true);
      head.appendChild(script);

      // Add CSS
      const link = document.createElement('link');
      link.id = 'calendly-css';
      link.setAttribute('href', 'https://assets.calendly.com/assets/external/widget.css');
      link.setAttribute('rel', 'stylesheet');
      head.appendChild(link);
    }
  }, []);

  const openCalendlyPopup = (e) => {
    e.preventDefault();
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/stoneageai73/30min?background_color=e8d1d1&text_color=09081e&primary_color=f9ec3f'
      });
      return false;
    }
  };

  return (
    <a 
      href="#" 
      onClick={openCalendlyPopup}
      className={className}
    >
      {children}
    </a>
  );
};

export default CalendlyPopup;